import React from 'react';
import { ShareLinkFieldType, ShareLinkFormType } from '../../form/link-config-form.factory';

import { useFormikContext } from 'formik';
import { SharePresentations } from '../../form/fields/presentation';

export const ShareConfigPresentationPanel = () => {
  const { values, setFieldValue } = useFormikContext<ShareLinkFormType>();

  const onFieldChange = (payload: ShareLinkFieldType<unknown>) => {
    setFieldValue(payload.field, payload.value);
  };

  return (
    <div className='flex flex-col space-y-4 py-6'>
      <SharePresentations
        presentation={{ field: 'presentation_mode', value: values.presentation_mode }}
        onFieldChange={onFieldChange}
      />
    </div>
  );
};
